var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn-text btn-sm pointer p-1 mr-1",class:_vm.classtext,attrs:{"title":_vm.hover_text},on:{"click":function($event){return _vm.postPin()}}},[_c('i',{staticClass:"fas fa-thumbtack"}),_c('span',{domProps:{"textContent":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }